import { CdkTreeModule,FlatTreeControl } from '@angular/cdk/tree';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy,Component, ContentChild, ContentChildren, Directive, Injectable,Input,OnInit,
    QueryList, TemplateRef } from '@angular/core';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatTreeFlattener,MatTreeModule } from '@angular/material/tree';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ArlTreeDataSource } from './arl-tree-data-source';


@Directive({
    selector: '[appArlTreeRow]',
    standalone: true,
})
export class ArlTreeRowDirective<T> {

    // damit der Angular Language Service per Strg+Click auf die Direktive hierher findet
    @Input() appArlTreeRow: undefined | '';
    constructor(public templateRef: TemplateRef<any>) {
    }
}

// @Directive({
//     selector: '[appArlTreeHeaderRow]',
//     standalone: true,
// })
// export class ArlTreeHeaderRow {
//
//     // damit der Angular Language Service per Strg+Click auf die Direktive hierher findet
//     @Input() appArlTreeHeaderRow: undefined | '';
//     constructor(public templateRef: TemplateRef<any>) {
//     }
// }


export type ArlTreeItem<T> = {
    position: string;
    // children?: ArlTreeItem<T>[];
    level: number;
    expandable: boolean;
    data: T;
};
@Component({
    selector: 'app-arl-tree',
    templateUrl: './arl-tree.component.html',
    styleUrls: ['./arl-tree.component.scss'],
    standalone: true,
    imports: [CommonModule, MatTreeModule, MatLegacyButtonModule, FontAwesomeModule, CdkTreeModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArlTreeComponent<T, F>/* implements OnInit*/ {
    @ContentChild(ArlTreeRowDirective) row: ArlTreeRowDirective<T>;
    // @ContentChildren(ArlTreeHeaderRow) headerRows: QueryList<ArlTreeHeaderRow>;

    private _itemFilter: (a: T) => boolean;
    @Input() set itemFilter(f: (a: T) => boolean) {
        console.log('setItemFilter', f);
        this._itemFilter = f;
        //this.setTreeFlattener();
        this.tryInitTree();
    }
    private _getChildren: (a: T) => T[];
    @Input() set getChildren(f: (a: T) => T[]) {
        this._getChildren = f;
       //this.setTreeFlattener();
        this.tryInitTree();
    }

    private _getPosition: (a: T) => string;
    @Input() set getPosition(f: (a: T) => string) {
        this._getPosition = f;
        //this.setTreeFlattener();
        this.tryInitTree();
    }

    private _data: T[];
    @Input() set data(data: T[]) {
        this._data = data;
        this.setData();
    }

    /** The MatTreeFlatDataSource connects the control and flattener to provide data. */
    public dataSource: ArlTreeDataSource<T, ArlTreeItem<T>, string>;
    public treeControl: FlatTreeControl<ArlTreeItem<T>, string> = new FlatTreeControl(
        (d) => d.level,
        (d) => d.expandable,
        { trackBy: (d) => d.position },
    );

    constructor() {
        // this.dataSource = new MatTreeFlatDataSource;
        this.dataSource = new ArlTreeDataSource(this.treeControl);
    }



    // ngOnInit(): void {
    //     // this.dataSource.data = this._data;
    // }
    private initialExpanded = false;

    private initDone = false;

    private tryInitTree() {
        if (this.initDone) return;

        if (this._getPosition && this._getChildren && this._itemFilter) {
            const _transformer = (node: T, level: number): ArlTreeItem<T> => ({
                expandable: this._getChildren(node).some(c => this._itemFilter(c)),
                level,
                position: this._getPosition(node),
                data: node,
            });

            this.dataSource._treeFlattener = new MatTreeFlattener(
                _transformer,
                (node) => node.level,
                (node) => node.expandable,
                (node) => this._getChildren(node).filter(c => this._itemFilter(c)),
            );

            this.initDone = true;

            this.setData(); // erst jetzt Daten setzen
        }
    }

    setTreeFlattener() {
        if (this._getPosition && this._getChildren && this._itemFilter) {
            const _transformer = (node: T, level: number): ArlTreeItem<T> => {
                return {
                    expandable: this._getChildren(node).some(c => this._itemFilter(c)),
                    level: level,
                    position: this._getPosition(node),
                    data: node,
                };
            };
            this.dataSource._treeFlattener = new MatTreeFlattener(
                _transformer,
                (node) => node.level,
                (node) => node.expandable,
                (node) => this._getChildren(node).filter(c => this._itemFilter(c)),
            );
            this.setData();
        }
    }
    setData() {

        if (this.dataSource._treeFlattener && this._getChildren && this._itemFilter) {

            // const  recFilter = (item:  T): boolean =>  {
            //     return this._itemFilter(item) || this._getChildren(item).some(child => recFilter(child));
            // }
            const cache = new Map<T, boolean>();

            const recFilter = (item: T): boolean => {
                if (cache.has(item)) return cache.get(item)!;

                const result =
                    this._itemFilter(item) ||
                    this._getChildren(item).some(child => recFilter(child));

                cache.set(item, result);
                return result;
            };
            this.dataSource.data = (this._data || []).filter(c => recFilter(c))
            if (!this.initialExpanded) {
                this.initialExpanded = true;

                Promise.resolve().then(() => {
                    this.treeControl.expandAll();
                });
            }
        }
    }
}




